/* eslint-disable max-lines-per-function */
import { isFunction } from "common/utils/helpers/is";
import logger from "../logger";
import retrySubmitMixpanelEvents from "./retry-mixpanel";

// Currently used for events that happen immediately before page navigation
const IMMEDIATE_SEND_EVENTS = ["start_designing_clicked"];

// eslint-disable-next-line import/prefer-default-export
export const track = (event, rest, options) => {
  const additionalParams = {};
  const orderNumberContainer = document.querySelector(".js-order-number-container");

  if (["checkout_started", "checkout_confirmed"].includes(event)) {
    const variantDetails = orderNumberContainer
      ? orderNumberContainer.dataset.mxVariantDetails
      : "";
    additionalParams.variant_details = variantDetails;
  }

  if (["checkout_started", "checkout_confirmed", "saved_carts_default_changed"].includes(event)) {
    if (orderNumberContainer?.dataset?.subOrdersCount > 0) {
      additionalParams.consolidated_cart = true;
      additionalParams.number_of_child_carts = orderNumberContainer.dataset.subOrdersCount;
    }
  }

  const properties = { ...rest, ...additionalParams };

  const finalOptions = IMMEDIATE_SEND_EVENTS.includes(event)
    ? { ...options, send_immediately: true, transport: "sendBeacon" }
    : options;

  if (window.mixpanel) {
    const timedEvents = {
      checkout_started: "checkout_page_rendered"
    };

    if (Object.keys(timedEvents).includes(event)) {
      window.mixpanel.time_event(timedEvents[event]);
    }

    window.mixpanel.track(event, properties, finalOptions);
  } else {
    retrySubmitMixpanelEvents(event, properties, finalOptions);
    if (window.ANALYTICS_LOGS_ENABLED) {
      logger.log(
        `Mixpanel Track ${event}: ${JSON.stringify(rest)} ${JSON.stringify(additionalParams)}`
      );
    }
  }
};

export const registerMixpanel = props => {
  window.mixpanel?.register(props);
};

export const startMixpanelRecording = (percent, { force = false } = {}) => {
  if (!force && !window.mixpanelSessionRecordingEnabled) {
    return false;
  }

  const shouldRecord = Math.random() * 100 <= percent;
  if (shouldRecord && window.mixpanel && isFunction(window.mixpanel.start_session_recording)) {
    window.mixpanel.start_session_recording();
    return true;
  }
  return false;
};
